function fetchSystemMessages(data, apiClient, priority, destination) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/systemMessages`;
  return apiClient.get(route, { query: { priority, destination } });
}

export default {
  fetchSystemMessages
};
